<nav aria-label="page navigation example">  
    <ul class="pagination">  
      <li class="page-item"  (click)="onClickPage(activePage - 1)"><a class="page-link" href="javascript:void(0);">&laquo; Previous</a></li>  
      <li class="page-item" [ngClass]="{'active': activePage === item}" *ngFor="let item of pages" (click)="onClickPage(item)"><a class="page-link" style="background-color:#5F9DF7; border-color:#FF731D;" href="javascript:void(0);">{{item}}</a></li>  
      <li class="page-item" (click)="onClickPage(activePage + 1)"><a class="page-link" href="javascript:void(0);">Next  &raquo;</a></li>  
    </ul>  
  </nav>  